import { Divider, Stack, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { PrincipalLayouts } from "../../layouts";
import { AdminPositionsTable, AdminDividendsTable } from "../components/positions";
import { PositionsTable } from "../components/positions/PositionsTable";
import { fetchData } from "../helpers/getData/fetchData";
import CircularProgress from "@mui/material/CircularProgress";
import { DivestmentClubTable } from "../components/divestment/DivestmentClubTable";
import { TotalPositionsClub } from "../components/positions/TotalPositionsClub";
import { TotalPositionSmall } from "../components/positions/TotalPositionSmall";
import { SearchByUser } from "../components/positions/search/SearchByUser";
import { SearchByStartup } from "../components/positions/search/SearchByStartup";
import { EditDivestmentClub } from "../components/divestment/EditDivestmentClub";
import { selectDivestmentClub } from "../../store/divestmentClub/divestmentClubSlice";

export const PositionsClub = () => {
  const { t } = useTranslation("global");
  const { role } = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const [investmentList, setInvestmentList] = useState("isLoading");
  const [opportunitiesList, setOpportunitiesList] = useState("isLoading");
  const [dividendsList, setDividendsList] = useState("isLoading");

  const [reloadData, setReloadData] = useState("isLoading");
  const [openEdit, setOpenEdit] = useState(false);
  const [vehicles, setVehicles] = useState("isLoading");
  const [divestmentList, setDivestmentList] = useState("isLoading");
  const [divestmentData, setDivestmentData] = useState(null);

  useEffect(() => {
    fetchData(setOpportunitiesList, "/opportunities/withInvestment", t);
    if (role === "Híbrido" || role === "Club") {
      fetchData(setInvestmentList, "/investments", t);
      fetchData(setDivestmentList, "/divestment", t);
    }
    if (role === "Admin") {
      fetchData(setVehicles, "/vehicle/nameList", t);
      fetchData(setDividendsList, "/dividends", t);
    } else {
      setVehicles([]);
      setDividendsList([]);
    }
  }, [t, reloadData, role]);

  const handleEdit = (e) => {
    dispatch(selectDivestmentClub(e.row));
    setOpenEdit(true);
  };

  return (
    <PrincipalLayouts>
      {role === "Admin" ? (
        <>
          {opportunitiesList !== "isLoading" &&
          role === "Admin" &&
          vehicles !== "isLoading" &&
          dividendsList !== "isLoading" ? (
            <Stack gap={8}>
              <AdminPositionsTable
                rows={opportunitiesList.filter(
                  (opp) => opp.haveConfirmedInvestment
                )}
                setReloadData={setReloadData}
                vehicles={vehicles}
              />
              <AdminDividendsTable
                rows={dividendsList}
                setReloadData={setReloadData}
              />
              <Stack>
                <Typography color="primary" variant="h6">
                  {t("tablestitles.divestmentClub")}
                </Typography>
                <Divider sx={{ marginBottom: "25px", marginTop: "10px" }} />
                <Stack gap={4} mb={4}>
                  <SearchByUser setReloadData={setReloadData} />
                  <SearchByStartup
                    setReloadData={setReloadData}
                    handleEdit={handleEdit}
                    divestmentData={divestmentData}
                    setDivestmentData={setDivestmentData}
                  />
                  {openEdit && (
                    <EditDivestmentClub
                      setHidden={setOpenEdit}
                      setDivestmentData={setDivestmentData}
                    />
                  )}
                </Stack>
              </Stack>
            </Stack>
          ) : (
            <Stack width="100%" alignItems="center" marginTop="100px">
              <CircularProgress />
            </Stack>
          )}
        </>
      ) : (
        <Stack gap={8}>
          {investmentList !== "isLoading" &&
            divestmentList !== "isLoading" &&
            (role === "Club" || role === "Híbrido") && (
              <>
                <Stack>
                  <Typography color="primary" variant="h6">
                    {t("tablestitles.positionsClubGral")}
                  </Typography>
                  <Divider sx={{ marginBottom: "25px", marginTop: "10px" }} />
                  <TotalPositionsClub
                    investmentList={investmentList}
                    divestmentList={divestmentList}
                  />
                  <TotalPositionSmall
                    investmentList={investmentList}
                    divestmentList={divestmentList}
                  />
                </Stack>
                <PositionsTable rows={investmentList} />
                <DivestmentClubTable rows={divestmentList} />
              </>
            )}
        </Stack>
      )}
    </PrincipalLayouts>
  );
};
